import styled from 'styled-components';

export const CircularButton = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	position: fixed;
	top: 137px;
	left: 240px;
	width: 57px;
	height: 57px;
	box-sizing: border-box;
	transform: translateX(-50%);
	cursor: pointer;
	background: ${({ theme }) => theme.colors.lightGrey};
	color: white;
	border-radius: 100%;
	border: none;
	z-index: 10;
`;
